var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-page content-wrapper"},[_c('iframe',_vm._b({attrs:{"id":"iframe","width":"100%","height":"100%","src":_vm.iframeUrl()}},'iframe',_vm.config.iframe,false))])}
var staticRenderFns = []

export { render, staticRenderFns }